import React from "react";
import { Link, cn } from "@heroui/react";

type SiteFooterProps = {
  className?: string;
};

export default function SiteFooter({ className }: SiteFooterProps) {
  return (
    <footer
      className={cn(
        "bg-default-50/5 border-default-100/40 mt-16 w-full border-t",
        className,
      )}
    >
      <div className="mx-auto flex max-w-6xl flex-col items-center justify-center gap-2 px-6 py-6 text-center text-[11px] leading-relaxed text-default-500 sm:px-8 sm:text-xs">
        <div className="flex flex-wrap items-center justify-center gap-x-3 gap-y-1">
          <Link href="/privacy" className="text-current hover:text-primary/80 hover:underline text-[11px] sm:text-xs">
            隐私政策
          </Link>
          <span className="text-default-400">·</span>
          <Link href="/cookie" className="text-current hover:text-primary/80 hover:underline text-[11px] sm:text-xs">
            Cookie 政策
          </Link>
          <span className="text-default-400">·</span>
          <Link href="/terms" className="text-current hover:text-primary/80 hover:underline text-[11px] sm:text-xs">
            服务条款
          </Link>
          <span className="text-default-400">·</span>
          <Link href="/data-security" className="text-current hover:text-primary/80 hover:underline text-[11px] sm:text-xs">
            数据安全管理规范
          </Link>
          <span className="text-default-400">·</span>
          <Link href="/risk-disclaimer" className="text-current hover:text-primary/80 hover:underline text-[11px] sm:text-xs">
            风险告知与免责声明
          </Link>
        </div>
        <p className="space-y-1">
          <span className="block sm:inline">
            © 2026, 3Chat.ai All rights reserved.
          </span>
          <span className="block sm:inline sm:ml-2">
            上海纽酷信息科技有限公司 沪ICP备18014720号-10 （3chatai.cn） | 沪ICP备18014720号-11 （3chatai.com）
          </span>
        </p>
      </div>
    </footer>
  );
}

